import axiosInstance from '../../../config/axiosInstance';
import { AgreementValidation } from "../View/Validation/AgreementValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = AgreementValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.formData.UserID=UserID;
     
      const response = await axiosInstance.post(`/Agreement/CreateAgreement`, formData);
     localStorage.setItem('AgreementID', response.data.AgreementID);
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };